import { CircularProgress } from '@material-ui/core';
import * as React from 'react';
import VerseVersions from '../search/VerseVersions';
import SearchQuery from '../search2/SearchQuery';
import SearchResultList from './SearchResultList';
import './SideSearchView.css';
import VerseSearchResult from './VerseSearchResult';
import VerseSearchResultText from './VerseSearchResultText';

interface Props {
    query?: SearchQuery;
    onVerseClick: (index: number) => void;
}

const SideSearchView: React.FunctionComponent<Props> = props => {

    const [results, setResults] = React.useState<VerseSearchResult[] | null>(null);
    const [resultsText, setResultsText] = React.useState<VerseSearchResultText[] | null>(null);
    const [searching, setSearching] = React.useState(false);

    React.useEffect(() => {
        if (props.query) {
            setSearching(true);
            const query = props.query;

            VerseVersions.search(query.getText(), query.getOptions(), 0, false)
                    .then((resultsResponse: VerseSearchResult[]) => {
                        setResults(resultsResponse);
                        setResultsText(null);
                        setSearching(false);

                        VerseVersions.search(query.getText(), query.getOptions(), 0, true)
                                .then((resultsTextResponse: VerseSearchResultText[]) => setResultsText(resultsTextResponse))
                                .catch(error => console.log(error));
                    })
                    .catch(error => console.log(error));
        } else {
            setResults(null);
            setResultsText(null);
            setSearching(false);
        }
    }, [props.query]);

    const onResultClick = (result: VerseSearchResult) => props.onVerseClick(result.index);

    let content;
    if (searching) {
        content = <CircularProgress className="SideSearchView_Loading" color="secondary" size={30} />;
    }
    else if (results && results.length > 0) {
        content = <SearchResultList
            results={results}
            resultsText={resultsText ? resultsText : undefined}
            query={props.query}
            onResultClick={onResultClick} />;
    } else {
        content = <div className="SideSearchView_Empty">No results</div>;
    }

    return (
        <div className="SideSearchView">
            <div className="SideSearchView_Content">{content}</div>
        </div>
    );
};

export default SideSearchView;
